import React, { useEffect, useState } from "react";
import "../assets/styles/menubar.css";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";

import MenuItem from "@mui/material/MenuItem";

import { NavHashLink } from "react-router-hash-link";
import MainLogo from "../assets/image/mainLogo.gif";
const Menubar = () => {
  const [topMenuBar, setTopMenuBar] = useState(false);
  const [resNavbar, setResNavbar] = useState(false);
  /**
   * If the window is scrolled down 500px, then set the topMenuBar to true, otherwise set it to false.
   */
  let resizeWindow = () => {
    if (window.scrollY >= 500) {
      setTopMenuBar(true);
    } else {
      setTopMenuBar(false);
    }
  };
  useEffect(() => {
    resizeWindow();
    window.addEventListener("scroll", resizeWindow);

    return () => window.removeEventListener("resize", resizeWindow);
  }, []);
  const menu = [
    { name: "Home", to: "home" },
    { name: "About", to: "about" },
    { name: "Project", to: "projects" },
    { name: "Blog", to: "blog" },
    { name: "Contact", to: "contact" },
  ];

  //testing navbar
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <>
      <AppBar
        style={{ backgroundColor: "#0E2A47" }}
        position={topMenuBar ? "fixed" : "static"}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            ></Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {menu.map((page, index) => (
                  <MenuItem key={index}>
                    <NavHashLink
                      className="menu_item"
                      style={{ textDecoration: "none", width: "100%" }}
                      onClick={handleCloseNavMenu}
                      sx={{
                        my: 2,
                        mt: 3,
                        color: "white",
                        display: "block",
                        width: "100%",
                      }}
                      to={`#${page.to}`}
                      smooth
                    >
                      {page.name}
                    </NavHashLink>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <img
              style={{ height: "50px", width: "50px" }}
              src={MainLogo}
              alt=""
            />
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {menu.map((page, index) => (
                <NavHashLink
                  key={index}
                  className="menu_item"
                  sx={{ my: 2, color: "white", display: "block" }}
                  to={`#${page.to}`}
                  smooth
                >
                  {page.name}
                </NavHashLink>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Menubar;
